// Esta configuración define los diagramas disponibles con sus títulos
// Los archivos .md están bundleados en src/data/diagrams/ y son cargados de forma segura
// mediante el servicio diagramLoader.js - NO son accesibles directamente por URL

// ============================================================================
// IMPORTS DE ARCHIVOS .MD
// ============================================================================
// Al agregar un nuevo diagrama, primero importa el archivo aquí

// Flujos
import flujoRegistro from './diagrams/flujos/flujo_registro.md';
import flujoImportarFraseSemilla from './diagrams/flujos/flujo_importar_frase_semilla.md';
import flujoReferidos from './diagrams/flujos/flujo_referidos.md';
import flujoObtencionUbicacion from './diagrams/flujos/flujo_obtencion_ubicacion.md';
import flujoBusqueda from './diagrams/flujos/flujo_busqueda.md';
import flujoEnvioMensajes from './diagrams/flujos/flujo_envio_mensajes.md';
import flujoGobernanza from './diagrams/flujos/flujo_gobernanza.md';
import flujoPanicoVidaHerederos from './diagrams/flujos/flujo_panico_vida_herederos.md';
import flujoBilletera from './diagrams/flujos/flujo_billetera.md';
import flujoLlamadas from './diagrams/flujos/flujo_llamadas.md';
import flujoTokenizacion from './diagrams/flujos/flujo_tokenizacion.md';
import flujoMarketplace from './diagrams/flujos/flujo_marketplace.md';
import flujoP2P from './diagrams/flujos/flujo_p2p.md';
import flujoTarjetasCripto from './diagrams/flujos/flujo_tarjetas_cripto.md';
import flujoCatalogos from './diagrams/flujos/flujo_catalogos.md';
import flujoVerificacionCuenta from './diagrams/flujos/flujo_verificacion_cuenta.md';
import flujoReporteUsuarios from './diagrams/flujos/flujo_reporte_usuarios.md';
import flujoEliminacionCuenta from './diagrams/flujos/flujo_eliminacion_cuenta.md';
import flujoComunidadesAnonimas from './diagrams/flujos/flujo_comunidades_anonimas.md';
import flujoHigAI from './diagrams/flujos/flujo_hig_ai.md';
import flujoPost from './diagrams/flujos/flujo_post.md';
import flujoVisibilidadPermisos from './diagrams/flujos/flujo_visibilidad_permisos.md';
import flujoDistribucion from './diagrams/flujos/flujo_distribucion.md';

// Seguridad
import arquitecturaSeguridad from './diagrams/seguridad/arquitectura_seguridad_no_custodial.md';

// Detalles técnicos
import stackTecnologico from './diagrams/detalles-tecnicos/stack_tecnologico.md';

// Backend
import stackTecnologicoBackend from './diagrams/backend/detalles-tecnicos/stack_tecnologico_backend.md';
import flujoNotificaciones from './diagrams/backend/flujos/flujo_notificaciones.md';
import flujoPropagacionMensajes from './diagrams/backend/flujos/flujo_propagacion_mensajes.md';
import flujoPresencia from './diagrams/backend/flujos/flujo_presencia.md';

// Blockchain
import stackTecnologicoBlockchain from './diagrams/blockchain/detalles-tecnicos/stack_tecnologico_blockchain.md';
import flujoContratoInteligente from './diagrams/blockchain/flujos/flujo_contrato_inteligente_hig.md';
import flujoContratoInteligenteComunidades from './diagrams/blockchain/flujos/flujo_contrato_inteligente_comunidades.md';

// Servidores
import detalleTecnicoServidores from './diagrams/servidores/infraestructura/detalle_tecnico_servidores.md';
import proveedores from './diagrams/servidores/infraestructura/proveedores.md';
import integracionesSlas from './diagrams/servidores/infraestructura/integraciones_slas.md';
import flujoBackups from './diagrams/servidores/respaldo/flujo_backups.md';
import drp from './diagrams/servidores/respaldo/drp.md';

// Control de Versiones
import flujoIntegracionDespliegue from './diagrams/control-versiones/github/flujo_integracion_despliegue.md';
import estructuraRamas from './diagrams/control-versiones/github/estructura_ramas.md';
import flujoDespliegueIOSAndroid from './diagrams/control-versiones/despliegue/flujo_despliegue_ios_android.md';

// ADR
import decisionesArquitectonicas from './diagrams/adr/decisiones_arquitectonicas.md';

// ============================================================================
// CONFIGURACIÓN DE DIAGRAMAS
// ============================================================================
// Al agregar un nuevo diagrama:
// 1. Importa el archivo arriba
// 2. Agrega el objeto del diagrama aquí con su propiedad 'file'
// 3. ¡Eso es todo! No necesitas modificar diagramLoader.js

// Nueva estructura con categorías y subcategorías
export const diagramCategories = [
  {
    id: 'aplicacion-movil',
    title: 'Aplicación móvil',
    subcategories: [
      {
        id: 'flujos-aplicacion',
        title: 'Flujos de la aplicación',
        diagrams: [
          {
            id: 'flujo-registro',
            title: 'Flujo de Registro',
            file: flujoRegistro
          },
          {
            id: 'flujo-importar-frase-semilla',
            title: 'Flujo de Importación de Cuenta',
            file: flujoImportarFraseSemilla
          },
          {
            id: 'flujo-referidos',
            title: 'Flujo de Referidos',
            file: flujoReferidos
          },
          {
            id: 'flujo-obtencion-ubicacion',
            title: 'Flujo de Obtención de Ubicación del Usuario',
            file: flujoObtencionUbicacion
          },
          {
            id: 'flujo-busqueda',
            title: 'Flujo de Búsqueda de Usuarios, Comunidades y Canales',
            file: flujoBusqueda
          },
          {
            id: 'flujo-envio-mensajes',
            title: 'Flujo de Mensajería',
            file: flujoEnvioMensajes
          },
          {
            id: 'flujo-gobernanza',
            title: 'Flujo de Gobernanza',
            file: flujoGobernanza
          },
          {
            id: 'flujo-panico-vida-herederos',
            title: 'Flujo de Pánico, Prueba de Vida y Herederos',
            file: flujoPanicoVidaHerederos
          },
          {
            id: 'flujo-billetera',
            title: 'Flujo de Billetera',
            file: flujoBilletera
          },
          {
            id: 'flujo-llamadas',
            title: 'Flujo de Llamadas y Videollamadas',
            file: flujoLlamadas
          },
          {
            id: 'flujo-tokenizacion',
            title: 'Flujo de Tokenización y Creación de Tokens',
            file: flujoTokenizacion
          },
          {
            id: 'flujo-marketplace',
            title: 'Flujo de Marketplace',
            file: flujoMarketplace
          },
          {
            id: 'flujo-p2p',
            title: 'Flujo de P2P, Pago a Comercios y QFlash',
            file: flujoP2P
          },
          {
            id: 'flujo-tarjetas-cripto',
            title: 'Flujo de Tarjetas Cripto',
            file: flujoTarjetasCripto
          },
          {
            id: 'flujo-catalogos',
            title: 'Flujo de Catálogos',
            file: flujoCatalogos
          },
          {
            id: 'flujo-verificacion-cuenta',
            title: 'Flujo de Verificación de Cuenta',
            file: flujoVerificacionCuenta
          },
          {
            id: 'flujo-reporte-usuarios',
            title: 'Flujo de Reporte de Usuarios',
            file: flujoReporteUsuarios
          },
          {
            id: 'flujo-eliminacion-cuenta',
            title: 'Flujo de Eliminación de Cuenta',
            file: flujoEliminacionCuenta
          },
          {
            id: 'flujo-comunidades-anonimas',
            title: 'Flujo de Comunidades Anónimas',
            file: flujoComunidadesAnonimas
          },
          {
            id: 'flujo-hig-ai',
            title: 'Flujo de Hi-G AI',
            file: flujoHigAI
          },
          {
            id: 'flujo-post',
            title: 'Flujo de Posts',
            file: flujoPost
          },
          {
            id: 'flujo-visibilidad-permisos',
            title: 'Flujo de Visibilidad y Permisos',
            file: flujoVisibilidadPermisos
          },
          {
            id: 'flujo-distribucion',
            title: 'Flujo de Distribucion',
            file: flujoDistribucion
          }
        ]
      },
      {
        id: 'seguridad',
        title: 'Seguridad',
        diagrams: [
          {
            id: 'arquitectura-seguridad',
            title: 'Arquitectura de Seguridad No Custodial',
            file: arquitecturaSeguridad
          }
        ]
      },
      {
        id: 'detalles-tecnicos',
        title: 'Detalles técnicos',
        diagrams: [
          {
            id: 'stack-tecnologico',
            title: 'Stack Tecnológico y Versiones Empleadas',
            file: stackTecnologico
          }
        ]
      }
    ]
  },
  {
    id: 'backend',
    title: 'Backend',
    subcategories: [
      {
        id: 'flujos',
        title: 'Flujos',
        diagrams: [
          {
            id: 'flujo-notificaciones',
            title: 'Sistema de Notificaciones Backend',
            file: flujoNotificaciones
          },
          {
            id: 'flujo-propagacion-mensajes',
            title: 'Flujo de Propagación de Mensajes',
            file: flujoPropagacionMensajes
          },
          {
            id: 'flujo-presencia',
            title: 'Flujo de Presencia',
            file: flujoPresencia
          }
        ]
      },
      {
        id: 'detalles-tecnicos-backend',
        title: 'Detalles técnicos',
        diagrams: [
          {
            id: 'stack-tecnologico-backend',
            title: 'Stack Tecnológico y Versiones del Backend',
            file: stackTecnologicoBackend
          }
        ]
      }
    ]
  },
  {
    id: 'blockchain',
    title: 'Blockchain',
    subcategories: [
      {
        id: 'flujos-blockchain',
        title: 'Flujos',
        diagrams: [
          {
            id: 'flujo-contrato-inteligente',
            title: 'Flujo de Contrato Inteligente Hi-G',
            file: flujoContratoInteligente
          },
          {
            id: 'flujo-contrato-inteligente-comunidades',
            title: 'Flujo de Contrato Inteligente Comunidades',
            file: flujoContratoInteligenteComunidades
          }
        ]
      },
      {
        id: 'detalles-tecnicos-blockchain',
        title: 'Detalles técnicos',
        diagrams: [
          {
            id: 'stack-tecnologico-blockchain',
            title: 'Stack Tecnológico y Versiones de Blockchain',
            file: stackTecnologicoBlockchain
          }
        ]
      }
    ]
  },
  {
    id: 'servidores',
    title: 'Servidores',
    subcategories: [
      {
        id: 'infraestructura',
        title: 'Infraestructura',
        diagrams: [
          {
            id: 'detalle-tecnico-servidores',
            title: 'Detalles Técnicos de Infraestructura',
            file: detalleTecnicoServidores
          },
          {
            id: 'proveedores',
            title: 'Proveedores de Servicios',
            file: proveedores
          },
          {
            id: 'integraciones-slas',
            title: 'Integraciones Externas y SLAs de Partners',
            file: integracionesSlas
          }
        ]
      },
      {
        id: 'respaldo',
        title: 'Respaldo',
        diagrams: [
          {
            id: 'flujo-backups',
            title: 'Flujo de Backups',
            file: flujoBackups
          },
          {
            id: 'drp',
            title: 'Plan de Recuperación ante Desastres (DRP)',
            file: drp
          }
        ]
      }
    ]
  },
  {
    id: 'control-versiones',
    title: 'Control de Versiones',
    subcategories: [
      {
        id: 'github',
        title: 'GitHub',
        diagrams: [
          {
            id: 'estructura-ramas',
            title: 'Estructura de Ramas',
            file: estructuraRamas
          },
          {
            id: 'flujo-integracion-despliegue',
            title: 'Flujo de Integración y Despliegue de Código',
            file: flujoIntegracionDespliegue
          }
        ]
      },
      {
        id: 'despliegue',
        title: 'Despliegue',
        diagrams: [
          {
            id: 'flujo-despliegue-ios-android',
            title: 'Flujo de Despliegue iOS y Android con Codemagic',
            file: flujoDespliegueIOSAndroid
          }
        ]
      }
    ]
  },
  {
    id: 'adr',
    title: 'ADR',
    diagrams: [
      {
        id: 'decisiones-arquitectonicas',
        title: 'Registro de Decisiones Arquitectónicas',
        file: decisionesArquitectonicas
      }
    ]
  }
];

// Mantener compatibilidad con código existente (lista plana)
export const diagramFiles = diagramCategories.flatMap(category => {
  if (category.subcategories) {
    return category.subcategories.flatMap(subcat => subcat.diagrams);
  }
  return category.diagrams || [];
});
